__turbopack_context__.v({
  "className": "jetbrains_mono_50f32045-module__Quf7Sa__className",
});
